import LoyaltyOperationsService from '../../../services/loyalty/operations'
import { responseError } from '../../../helpers/loyalty'

export const state = {}

export const mutations = {}

export const getters = {}

// Estos endpoints devuelven el JSON tal cual (sin envoltorio). Cuando no pueden
// atender el pedido responden 200 con `{ error: { code, message } }`: eso se
// rechaza igual que un error de red, para que la pantalla lo muestre.
const call = request => {
  return new Promise((resolve, reject) => {
    request.then(response => {
      const error = responseError(response.data)
      if (error) {
        reject(error)
      } else {
        resolve(response.data)
      }
    })
    .catch(error => { reject(error) })
  });
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  getLoyaltyMembers ({ commit }, params) {
    return call(LoyaltyOperationsService.getMembers(params))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyMember ({ commit }, params) {
    return call(LoyaltyOperationsService.getMember(params))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyTransactions ({ commit }, params) {
    return call(LoyaltyOperationsService.getTransactions(params))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltySummary ({ commit }, params) {
    return call(LoyaltyOperationsService.getSummary(params))
  },

  // eslint-disable-next-line no-unused-vars
  createLoyaltyAdjustment ({ commit }, params) {
    return call(LoyaltyOperationsService.createAdjustment(params))
  },

  // eslint-disable-next-line no-unused-vars
  simulateLoyalty ({ commit }, params) {
    return call(LoyaltyOperationsService.simulate(params))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyRewards ({ commit }, params) {
    return call(LoyaltyOperationsService.getRewards(params))
  },

  // eslint-disable-next-line no-unused-vars
  createLoyaltyReward ({ commit }, payload) {
    return call(LoyaltyOperationsService.createReward(payload))
  },

  // eslint-disable-next-line no-unused-vars
  updateLoyaltyReward ({ commit }, payload) {
    return call(LoyaltyOperationsService.updateReward(payload))
  },

  // eslint-disable-next-line no-unused-vars
  deleteLoyaltyReward ({ commit }, rewardId) {
    return call(LoyaltyOperationsService.deleteReward(rewardId))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyRewardStats ({ commit }, params) {
    return call(LoyaltyOperationsService.getRewardStats(params))
  },

  // eslint-disable-next-line no-unused-vars
  grantLoyaltyReward ({ commit }, params) {
    return call(LoyaltyOperationsService.grantReward(params))
  },

  // eslint-disable-next-line no-unused-vars
  claimLoyaltyReward ({ commit }, params) {
    return call(LoyaltyOperationsService.claimReward(params))
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyVouchers ({ commit }, params) {
    return call(LoyaltyOperationsService.getVouchers(params))
  },

  // eslint-disable-next-line no-unused-vars
  cancelLoyaltyVoucher ({ commit }, params) {
    return call(LoyaltyOperationsService.cancelVoucher(params))
  },
}
